<template>
  <div class="new">
    <header>
      <img src="../assets/banner9.png" alt="">
    </header>
    <div class="headline">
      <h1>新闻中心</h1>
      <span>News</span>
    </div>
    <div class="news">
      <swiper class="core" :options="swiperOptions" ref="mySwiper">
        <swiper-slide v-for="(item,index) in newCenter" :key="index" >
          <dl @click="toArticle(item)">
            <dt>
              <img :src="item.logo_url" alt="">
            </dt>
            <dd>
              <p>{{ item.title }}</p>
              <p>{{ item.simple_info }}</p>
              <p>发布时间：{{ item.create_time }}</p>
            </dd>
          </dl>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <Newest :logisticsNews="logisticsNews" @toArticle="toArticle"></Newest>
    <tips :flag="tipsFlag"></tips>
  </div>
</template>
<script>
import Newest from '../components/Newest'
import { mapState } from 'vuex'
import { swiper,swiperSlide } from 'vue-awesome-swiper'
import { get_news_list } from "../services/selectSide"
import tips from '../components/tips'
export default {
  name:'News',
  props:{

  },
  components:{
    Newest,
    swiper,
    swiperSlide,
    tips
  },
  data(){
    return {
        tipFlag:false,
      swiperOptions:{
        slidesPerView: 3,
        spaceBetween: 30,
        slidesPerGroup: 1,
        autoplay: true,
        pagination:{
          el:'.swiper-pagination',
          clickable:true,
        }
      },
        newCenter:[],
        logisticsNews:[],
    }
  },
  computed:{
    ...mapState({
      imgIndex:state=>state.imgIndex,
      arr:state=>state.arr,
      tipsFlag: state => state.tipsFlag
    })
  },
  methods:{
      toArticle(item){
          if(item.content){
              this.$store.commit('setArticle',item)
              this.$router.push('/NewDetail')
          }else{
            this.$store.commit('setTipsFlag', {tips: '当前文章没有详情', search_flag: true, tipsCode: 2});
          }

      }

  },
  created(){
      var content = {
          info_type:'2',
          if_roll:'-1',
          if_point:'-1',
          keyword:'-1',
          limit	:'0',
          offset:'6'
      };
      get_news_list({content:JSON.stringify(content)}).then((res)=>{
          if(res.code == 1){
              // this.newCenter = res.data.info
              this.newCenter = res.data.info
          }
      })
      var logisticsContent = {
          info_type:'3',
          if_roll:'-1',
          if_point:'-1',
          keyword:'-1',
          limit	:'0',
          offset:'3'
      }
      get_news_list({content:JSON.stringify(logisticsContent)}).then((res)=>{
          if(res.code == 1){
              this.logisticsNews = res.data.info
          }
      })


  },
  mounted(){

  }
}
</script>
<style lang="scss">
  #tips {
    min-width: 200px;
    height: 50px;
    background: #666;
    position: fixed;
    top: 50%;
    left: 50%;
    margin-top: -25px;
    margin-left: -100px;
    z-index: 10000000;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    padding: 0 10px;
    box-sizing: border-box;
    opacity: 1;
    transition: all 0.3s;

    p {
      font-size: 17px;
      color: #fff;
    }
  }
  #tips.no{
    opacity: 0;
  }
.headline {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  h1{
    font-weight: normal;
  }
}

.news {
  width: 1000px;
  margin: 0 auto;
  height: 440px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .core {
    width: 100%;
    height: 510px;
    display: flex;
    dl {
      cursor: pointer;
      width: 100%;
      height: 360px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      background: #f8f8f8;
      margin: 0 12px;
      dt {
        width: 100%;
        height: 241px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      dd {
        width: 100%;
        height: 115px;
        display: flex;
        flex-direction: column;
        padding: 5px 20px;
        p:nth-child(1) {
          font-size: 14px;
          color: #000;
          margin-top: 15px;
          margin-bottom: 8px;
        }
        p {
          padding: 0 10px;
          font-size: 12px;
          margin: 5px 0;
          color: #adafb1;
          line-height: 16px;
        }
      }
    }
    .swiper-pagination {
      bottom: 10px;

      width:auto;
      height: 50px;
      left: 0;
      right: 0 ;
      margin: 0 auto;
      .swiper-pagination-bullet {
        width: 30px;
        height: 5px;
        display: inline-block;
        background: #666;
        margin: 0 5px;
        border-radius: 0;
      }
      .swiper-pagination-bullet-active {
        opacity: 1;
        background-color: $bg-color;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/News.vue